import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PoundCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/PoundCircleOutlined";
import AntdIcon from "../components/AntdIcon";
var PoundCircleOutlined = function PoundCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PoundCircleOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PoundCircleOutlined.displayName = 'PoundCircleOutlined';
}
export default /*#__PURE__*/React.forwardRef(PoundCircleOutlined);